<template>
  <div>
    <h3>Bounding Boxes</h3>
    <div>
      <information
        >Changing this setting will only apply to new items that are added. It
        will not update any existing items.</information
      >
      <switch-field
        v-model="hidden"
        id="disable-bounding-boxes"
        label="Hide bounding boxes"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Information from "@/components/common/banners/Information.vue";

export default {
  components: { Information },
  computed: {
    ...mapState({
      boundingBoxesHidden: (state) => state.boundingBoxesHidden,
    }),
    hidden: {
      get: function () {
        return this.boundingBoxesHidden;
      },
      set: function (value) {
        this.hideBoundingBoxes(value);
      },
    },
  },
  methods: {
    ...mapActions({
      hideBoundingBoxes: "hideBoundingBoxes",
    }),
  },
};
</script>